// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdatePhoto_addPhotosContainer__nacHl {
  width: 100%;
  margin: 12px auto 0 auto;
  font-size: 20px;
}

.UpdatePhoto_addPhotosTitle__m0omG {
  margin-bottom: 8px;
}

.UpdatePhoto_addFirstPhotoWrapper__C7ksy {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  border: 1px solid rgba(17, 24, 39, 0.1);
  border-radius: 10px;
  transition: border 0.2s;
  cursor: pointer;
}

.UpdatePhoto_addFirstPhotoWrapper__C7ksy input[type=file],
.UpdatePhoto_addMorePhotos__l2aha input[type=file] {
  display: none;
}

.UpdatePhoto_fontGrayThin__dmW1D {
  color: gray;
  font-size: 16px;
  font-weight: 400;
}

.UpdatePhoto_addPhotoButton__X1NBL {
  width: 254px;
  height: 50px;
  background-color: rgba(17, 24, 39, 0.1);
  margin-top: 24px;
  color: black;
  font-weight: 400;
  font-size: 16px;
  transition: background-color 0.2s, color 0.2s;
  border-radius: 30px;
}

.UpdatePhoto_addFirstPhotoWrapper__C7ksy:hover {
  border: 1px solid rgba(255, 111, 25, 0.3);
}
.UpdatePhoto_addFirstPhotoWrapper__C7ksy:hover .UpdatePhoto_addPhotoButton__X1NBL {
  background-color: #ff6f19;
  color: white;
}

.UpdatePhoto_photosWrapper__FyxH7 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.UpdatePhoto_imagesCounter__7NqaI {
  background-color: #f0f0f0;
  border-radius: 10px;
  padding: 8px 18px;
  margin-left: 12px;
}

.UpdatePhoto_photoContainer__Rgjcy {
  display: inline-block;
  position: relative;
  margin: 10px;
}

.UpdatePhoto_photoContainer__Rgjcy img {
  width: 180px;
  height: 130px;
  border-radius: 10px;
}

.UpdatePhoto_addMorePhotos__l2aha {
  margin-top: 10px;
  margin-left: 10px;
  width: 180px;
  height: 130px;
  border-radius: 10px;
  border: 1px solid rgba(59, 68, 255, 0.1);
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: border 0.2s;
}

.UpdatePhoto_addMorePhotoButton__PkLrn {
  width: 150px;
  height: 40px;
  background-color: rgba(17, 24, 39, 0.1);
  margin-top: 15px;
  border-radius: 30px;
  color: black;
  font-weight: 400;
  font-size: 16px;
  transition: background-color 0.2s, color 0.2s;
  white-space: normal;
  max-width: 80%;
}

.UpdatePhoto_addMorePhotos__l2aha:hover {
  border: 1px solid rgba(255, 111, 25, 0.3);
}
.UpdatePhoto_addMorePhotos__l2aha:hover .UpdatePhoto_addMorePhotoButton__PkLrn {
  background-color: #ff6f19;
  color: white;
}

.UpdatePhoto_crossButton__VFcK\\+ {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 33px;
  height: 33px;
  opacity: 85%;
  padding-left: 1px;
  background-color: #e7e8e9;
  transition: background-color 0.2s, color 0.2s;
}

.UpdatePhoto_crossButton__VFcK\\+:hover {
  background-color: #ff6f19;
}
.UpdatePhoto_crossButton__VFcK\\+:hover .UpdatePhoto_crossSvg__keroD {
  stroke: white;
}

.UpdatePhoto_loadingDots__N\\+INy::after {
  content: "...";
  display: inline-block;
  width: 1.5em;
  text-align: left;
  animation: UpdatePhoto_dots__EK3w2 1.5s infinite;
}

@keyframes UpdatePhoto_dots__EK3w2 {
  0% {
    content: "";
  }
  33% {
    content: ".";
  }
  66% {
    content: "..";
  }
  99% {
    content: "...";
  }
}
@media (width <= 530px) {
  .UpdatePhoto_photoContainer__Rgjcy img {
    width: 140px;
    height: 95px;
    border-radius: 10px;
  }
  .UpdatePhoto_addMorePhotos__l2aha {
    width: 140px;
    height: 95px;
  }
  .UpdatePhoto_addMorePhotoButton__PkLrn {
    margin-bottom: 5px;
    padding: 4px;
    font-size: 16px;
    margin-top: 5px;
  }
}
@media (width <= 410px) {
  .UpdatePhoto_photoContainer__Rgjcy img {
    width: 120px;
    height: 87px;
  }
  .UpdatePhoto_addMorePhotos__l2aha {
    width: 120px;
    height: 87px;
  }
  .UpdatePhoto_addMorePhotoButton__PkLrn {
    margin-bottom: 10px;
    padding: 4px;
    font-size: 12px;
  }
}
@media (width <= 360px) {
  .UpdatePhoto_photoContainer__Rgjcy img {
    width: 110px;
    height: 80px;
  }
  .UpdatePhoto_addMorePhotos__l2aha {
    width: 110px;
    height: 80px;
  }
  .UpdatePhoto_addMorePhotoIcon__TTs8q {
    transform: scale(0.75);
  }
}
@media (width <= 340px) {
  .UpdatePhoto_photoContainer__Rgjcy img {
    width: 100px;
    height: 70px;
    border-radius: 10px;
  }
  .UpdatePhoto_addMorePhotos__l2aha {
    width: 100px;
    height: 70px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/UpdatePhoto/UpdatePhoto.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,wBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,uCAAA;EACA,gBAAA;EAEA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,mBAAA;AACF;;AAEA;EACE,yCAAA;AACF;AAAE;EACE,yBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EAEA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,uCAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,yCAAA;AACF;AAAE;EACE,yBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,6CAAA;AACF;;AAEA;EACE,yBAAA;AACF;AAAE;EACE,aAAA;AAEJ;;AAEA;EACE,cAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AACF;;AAEA;EACE;IAAK,WAAA;EAEL;EADA;IAAM,YAAA;EAIN;EAHA;IAAM,aAAA;EAMN;EALA;IAAM,cAAA;EAQN;AACF;AANA;EACE;IACE,YAAA;IACA,YAAA;IACA,mBAAA;EAQF;EALA;IACE,YAAA;IACA,YAAA;EAOF;EAJA;IACE,kBAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EAMF;AACF;AAHA;EACE;IACE,YAAA;IACA,YAAA;EAKF;EAFA;IACE,YAAA;IACA,YAAA;EAIF;EADA;IACE,mBAAA;IACA,YAAA;IACA,eAAA;EAGF;AACF;AAAA;EACE;IACE,YAAA;IACA,YAAA;EAEF;EACA;IACE,YAAA;IACA,YAAA;EACF;EAEA;IACE,sBAAA;EAAF;AACF;AAGA;EACE;IACE,YAAA;IACA,YAAA;IACA,mBAAA;EADF;EAIA;IACE,YAAA;IACA,YAAA;EAFF;AACF","sourcesContent":[".addPhotosContainer {\n  width: 100%;\n  margin: 12px auto 0 auto;\n  font-size: 20px;\n}\n\n.addPhotosTitle {\n  margin-bottom: 8px;\n}\n\n.addFirstPhotoWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 0;\n  border: 1px solid rgb(17 24 39 / 0.1);\n  border-radius: 10px;\n  transition: border 0.2s;\n  cursor: pointer;\n}\n\n.addFirstPhotoWrapper input[type=\"file\"],\n.addMorePhotos input[type=\"file\"] {\n  display: none;\n}\n\n.fontGrayThin {\n  color: gray;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.addPhotoButton {\n  width: 254px;\n  height: 50px;\n  background-color: rgb(17 24 39 / 0.1);\n  margin-top: 24px;\n  border-radius: 10px;\n  color: black;\n  font-weight: 400;\n  font-size: 16px;\n  transition: background-color 0.2s, color 0.2s;\n  border-radius: 30px;\n}\n\n.addFirstPhotoWrapper:hover {\n  border: 1px solid rgb(255 111 25 / 0.3);\n  .addPhotoButton {\n    background-color: #ff6f19;\n    color: white;\n  }\n}\n\n.photosWrapper {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.imagesCounter {\n  background-color: #f0f0f0;\n  border-radius: 10px;\n  padding: 8px 18px;\n  margin-left: 12px;\n}\n\n.photoContainer {\n  display: inline-block;\n  position: relative;\n  margin: 10px;\n}\n\n.photoContainer img {\n  width: 180px;\n  height: 130px;\n  border-radius: 10px;\n}\n\n.addMorePhotos {\n  margin-top: 10px;\n  margin-left: 10px;\n  width: 180px;\n  height: 130px;\n  border-radius: 10px;\n  border: 1px solid rgba(59, 68, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  transition: border 0.2s;\n}\n\n.addMorePhotoButton {\n  width: 150px;\n  height: 40px;\n  background-color: rgb(17 24 39 / 0.1);\n  margin-top: 15px;\n  border-radius: 30px;\n  color: black;\n  font-weight: 400;\n  font-size: 16px;\n  transition: background-color 0.2s, color 0.2s;\n  white-space: normal; \n  max-width: 80%;\n}\n\n.addMorePhotos:hover {\n  border: 1px solid rgb(255 111 25 / 0.3);\n  .addMorePhotoButton {\n    background-color: #ff6f19;\n    color: white;\n  }\n}\n\n.crossButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: 33px;\n  height: 33px;\n  opacity: 85%;\n  padding-left: 1px;\n  background-color: #e7e8e9;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.crossButton:hover {\n  background-color: #ff6f19;\n  .crossSvg {\n    stroke: white;\n  }\n}\n\n.loadingDots::after {\n  content: '...';\n  display: inline-block;\n  width: 1.5em;\n  text-align: left;\n  animation: dots 1.5s infinite;\n}\n\n@keyframes dots {\n  0% { content: ''; }\n  33% { content: '.'; }\n  66% { content: '..'; }\n  99% { content: '...'; }\n}\n\n@media (width <= 530px) {\n  .photoContainer img {\n    width: 140px;\n    height: 95px;\n    border-radius: 10px;\n  }\n\n  .addMorePhotos {\n    width: 140px;\n    height: 95px;\n  }\n\n  .addMorePhotoButton {\n    margin-bottom: 5px;\n    padding: 4px;\n    font-size: 16px;\n    margin-top: 5px;\n  }\n}\n\n@media (width <= 410px) {\n  .photoContainer img {\n    width: 120px;\n    height: 87px;\n  }\n\n  .addMorePhotos {\n    width: 120px;\n    height: 87px;\n  }\n\n  .addMorePhotoButton {\n    margin-bottom: 10px;\n    padding: 4px;\n    font-size: 12px;\n  }\n}\n\n@media (width <= 360px) {\n  .photoContainer img {\n    width: 110px;\n    height: 80px;\n  }\n\n  .addMorePhotos {\n    width: 110px;\n    height: 80px;\n  }\n\n  .addMorePhotoIcon {\n    transform: scale(0.75);\n  }\n}\n\n@media (width <= 340px) {\n  .photoContainer img {\n    width: 100px;\n    height: 70px;\n    border-radius: 10px;\n  }\n\n  .addMorePhotos {\n    width: 100px;\n    height: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addPhotosContainer": `UpdatePhoto_addPhotosContainer__nacHl`,
	"addPhotosTitle": `UpdatePhoto_addPhotosTitle__m0omG`,
	"addFirstPhotoWrapper": `UpdatePhoto_addFirstPhotoWrapper__C7ksy`,
	"addMorePhotos": `UpdatePhoto_addMorePhotos__l2aha`,
	"fontGrayThin": `UpdatePhoto_fontGrayThin__dmW1D`,
	"addPhotoButton": `UpdatePhoto_addPhotoButton__X1NBL`,
	"photosWrapper": `UpdatePhoto_photosWrapper__FyxH7`,
	"imagesCounter": `UpdatePhoto_imagesCounter__7NqaI`,
	"photoContainer": `UpdatePhoto_photoContainer__Rgjcy`,
	"addMorePhotoButton": `UpdatePhoto_addMorePhotoButton__PkLrn`,
	"crossButton": `UpdatePhoto_crossButton__VFcK+`,
	"crossSvg": `UpdatePhoto_crossSvg__keroD`,
	"loadingDots": `UpdatePhoto_loadingDots__N+INy`,
	"dots": `UpdatePhoto_dots__EK3w2`,
	"addMorePhotoIcon": `UpdatePhoto_addMorePhotoIcon__TTs8q`
};
export default ___CSS_LOADER_EXPORT___;
